import * as firebase from 'firebase';
import * as mat from 'material-ui';

import { browserHistory } from 'react-router';
import { PlayOptions, playKeyDispatch, setCurrentQuizDisp, playingQuizDispatch } from '../reducers/container/playDispatch'
import getYouTubeID from 'get-youtube-id'




export function PlayOptionsAction(action) {
    return dispatch => {

        dispatch(PlayOptions(action))
        browserHistory.push('/play-option');

    }
}

// Work for Solo =====================================================================================

function getKeySolo(action) {
    return dispatch => {
        var text = "";
        var possible = "0123456789";
        // let userUid = firebase.auth().currentUser.uid;
        for (var i = 0; i < 4; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        var keyObj = {
            quizTitle: action,
            key: text,
            time: firebase.database.ServerValue.TIMESTAMP,
            type: 'solo1on1',
            players: [],
            currentQuizIndex: 0,
            generatorId: firebase.auth().currentUser.uid
        }
        firebase.database().ref('gameRom/' + keyObj.key + '/').once("value", (obj) => {
            let keyData = obj.val();
            if (keyData === null) {
                // console.log(keyObj, 'Data not found')
                dispatch(savePin(keyObj))
            }
            else {
                let checkTime = firebase.database.ServerValue.TIMESTAMP
                if (checkTime - keyData.time > 3600000) {
                    // console.log(keyObj, 'Data found')
                    dispatch(savePin(keyObj))
                }
                else {
                    dispatch(getKeySolo(action))
                }
            }
        })
    }
}

export function singlePlayerAction(action) {
    return dispatch => {
        dispatch(getKeySolo(action))
    }
}

// Work for team =====================================================================================

function getKeyTeam(action) {
    return dispatch => {
        var text = "";
        var possible = "0123456789";
        // let userUid = firebase.auth().currentUser.uid;
        for (var i = 0; i < 4; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        var keyObj = {
            quizTitle: action,
            key: text,
            time: firebase.database.ServerValue.TIMESTAMP,
            type: 'Team',
            players: [],
            currentQuizIndex: 0,
            generatorId: firebase.auth().currentUser.uid
        }
        // let dummy = '3S2yH'
        firebase.database().ref('gameRom/' + keyObj.key + '/').once("value", (obj) => {
            let keyData = obj.val();
            if (keyData === null) {
                // console.log(keyObj, 'Data not found')
                // savePin(keyObj);
                dispatch(savePin(keyObj));
            }
            else {
                // console.log(keyObj, 'Data found')
                let checkTime = firebase.database.ServerValue.TIMESTAMP
                if (checkTime - keyData.time > 3600000) {

                    dispatch(savePin(keyObj));
                }
                else {
                    dispatch(getKeyTeam(action));
                }
            }
        })
    }

}

export function teamPlayersAction(action) {
    return dispatch => {
        dispatch(getKeyTeam(action));
    }
}

function savePin(gameRom) {
    return dispatch => {
        firebase.database().ref('gameRom/' + gameRom.key + '/').set(gameRom)
            .then(() => {
                firebase.database().ref('test/' + gameRom.quizTitle + '/').once("value", (obj) => {
                    let playingQuizData = obj.val();
                    var id = getYouTubeID(playingQuizData.introVideos);
                    // console.log("code id here", id)
                    dispatch(playingQuizDispatch(id))
                    dispatch(playKeyDispatch(gameRom))
                    browserHistory.push("/playingkey")
                    // // console.log('playing key created', gameRom)
                })
            })
            .catch(() => {
                console.log('playing key is not created')
            })
    }
}

export function setCurrentQuiz(currentQuiz) {
    return dispatch => {
        dispatch(setCurrentQuizDisp(currentQuiz))
        browserHistory.push('/quizquestion');

    }
}


// WEBPACK FOOTER //
// ./src/action/playAction.jsx